import React from 'react';
import { renderInlineReferences } from '../parseInlineReferences';

const Paragraph = ({ block, onReferenceClick }) => (
  <p>{renderInlineReferences(block.text, onReferenceClick)}</p>
);

export default Paragraph;
